import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './forceChange.module.scss';

const Step1 = ({
  handleInputChange,
  checkPasswordMatch,
  newPasswordEmpty,
  confirmPasswordEmpty,
  passwordMatches,
  checkEmptyFields,
  invalidPassword
}) => (
  <div className={styles.form} style={{ height: 400 }}>
    <div className={styles.header}>
      <FormattedMessage id="authentication.force_change_new_password.header" defaultMessage="Set your new password" />
    </div>
    <div className={styles.message}>
      <FormattedMessage id="authentication.force_change_new_password.message" defaultMessage="Please set a new password of your choice.
       Ensure that the new password is at least 8 characters long,
        has at least one uppercase character,
         one number and a special character."
      />
    </div>
    <div className={styles.labelInput}>
      <label htmlFor="newPassword">
        <FormattedMessage id="authentication.force_reset_password.new_password" defaultMessage="New Password" />
        <input
          type="password"
          name="newPassword"
          onChange={(e) => { handleInputChange('newPassword', e.target.value); }}
          onBlur={(e) => { checkEmptyFields(e); }}
        />
      </label>
    </div>
    {newPasswordEmpty ? null: (
      <div className={styles.error}>
        <small>
          <FormattedMessage id="authentication.login.error.password_empty" defaultMessage="This field cannot be empty" />
        </small>
      </div>)}
    <div className={styles.labelInput}>
      <label htmlFor="confirmPassword">
        <FormattedMessage id="authentication.force_reset_password.confirm_password" defaultMessage="Confirm New Password" />
        <input
          type="password"
          name="confirmPassword"
          onChange={(e) => { handleInputChange('confirmPassword', e.target.value); }}
          onBlur={(e) => { checkPasswordMatch(e.target.value); checkEmptyFields(e); }}
        />
      </label>
    </div>
    {confirmPasswordEmpty ? null: (
      <div className={styles.error}>
        <small>
          <FormattedMessage id="authentication.login.error.password_empty" defaultMessage="This field cannot be empty" />
        </small>
      </div>)}
    {passwordMatches ? null : (
      <div className={styles.error}>
        <small>
          <FormattedMessage id="authentication.force_reset_password.password_mismatch" defaultMessage="Password and confirmation do not match" />
        </small>
      </div>)}
    {invalidPassword ? (
      <div className={`${styles.error} ${styles.invalidPassword}`}>
        <small>
          <FormattedMessage id="authentication.force_reset_password.invalid_password" defaultMessage="The password is invalid" />
        </small>
      </div>
    ) : null}
    <div className={styles.policies}>
      <FormattedMessage id="authentication.force_reset_Password.policies" defaultMessage="Clicking on the next button,
      I agree to the {Policy} and {Terms} of Aerosimple LLC"
        values={{ Policy: <u style={{ color: 'blue' }}>
          <FormattedMessage
            id="policy"
            defaultMessage="Privacy Policy"
          />
                          </u>,
        Terms: <u style={{ color: 'blue' }}>
          <FormattedMessage
            id="terms"
            defaultMessage="Terms and Conditions"
          />
               </u>
        }}
      />
    </div>
  </div>
);


Step1.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  checkPasswordMatch: PropTypes.func.isRequired,
  checkEmptyFields: PropTypes.func.isRequired,
  passwordMatches: PropTypes.bool.isRequired,
  invalidPassword: PropTypes.bool.isRequired,
  newPasswordEmpty: PropTypes.bool.isRequired,
  confirmPasswordEmpty: PropTypes.bool.isRequired
};

export default Step1;
